import forEach from 'lodash/forEach';

function validateCheckCounts(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if ((check.type === 'MEDICATION_ADMINISTERED' || check.type === 'OXYGEN_ADMINISTERED') &&
          check.count === 1 && check.countOperator === 'LESS_THAN') {
        warnings.push(lessThanOneWarning(node.id, checkKey));
      }
      if (check.id === 'DEFIBRILLATION' && check.count === 1 && check.operator === 'LESS_THAN') {
        warnings.push(lessThanOneWarning(node.id, checkKey));
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

function lessThanOneWarning(nodeId, checkKey) {
  return {
    message: 'Less than 1 checks will always return No.',
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      nodeId: nodeId,
      scope: 'control',
      checkKey,
      countWarning: true,
      defaultVisibility: false,
    },
  };
}

export default validateCheckCounts;